<template>
    <b-card>
        <b-tabs content-class="mt-3">
            <b-tab title="Primary Details" active>
                <b-card-text>
                    <b-form-group label="Source:" label-cols-sm="3" label-class="font-weight-bold pt-0"
                        label-align-sm="right">
                        <em> {{ sourceCompany }}
                        </em>
                    </b-form-group>
                    
                    <b-form-group label="Destination:" label-cols-sm="3" label-class="font-weight-bold pt-0"
                        label-align-sm="right">
                        <em>
                            {{ destinationCompany }}
                        </em>
                        &nbsp;&nbsp;
                    </b-form-group>

                    <b-form-group label="Location:" label-cols-sm="3" label-class="font-weight-bold pt-0"
                        label-align-sm="right">
                        <strong>
                            <b-button size="sm" v-b-tooltip.hover.top="'Show/Hide Map Location'"
                                @click.stop="showDispatchLocation(row.item)" variant="success" class="mr-1">
                                <em class="fa fa-map-marker fa-lg"></em>
                            </b-button>
                        </strong>
                        {{ getCoordinates(row.item) }}
                    </b-form-group>

                    <b-form-group label="Driver:" label-cols-sm="3" label-class="font-weight-bold pt-0"
                        label-align-sm="right">
                        {{ row.item.driver.name }}
                    </b-form-group>

                    <b-form-group label="Plate No/CR/OR:" label-cols-sm="3" label-class="font-weight-bold pt-0"
                        label-align-sm="right">
                        {{ row.item.transportation.plateNo }}
                    </b-form-group>

                    <b-form-group label="Date Created:" label-cols-sm="3" label-class="font-weight-bold pt-0"
                        label-align-sm="right">
                        {{ showFormattedDate(row.item.dateCreated) }}
                    </b-form-group>
                </b-card-text>
            </b-tab>
        </b-tabs>

        <b-row class="mt-4 mb-2">
            <b-col sm="12" class="text-sm-right">
                <b-button size="sm" @click="row.toggleDetails" variant="secondary" v-b-tooltip.hover.top="'Hide Details'">
                    <em class="icon-arrow-up"></em>
                </b-button>
            </b-col>
        </b-row>

    </b-card>
</template>

<script>
// Util
import { DateUtil } from '@/utils/dateutil';
import { LocationUtil } from '@/utils/locationUtil';
import { DispatchUtil } from '@/utils/dispatchUtil';

// Others
import EventBus from '@/shared/event-bus';
import _ from 'lodash';

export default {
    name: 'dispatch-alert-details-view',
    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    computed: {
        sourceCompany() {
            return DispatchUtil.getCompanyLocationDisplay(this.row.item.source);
        },
        destinationCompany() {
            return DispatchUtil.getCompanyLocationDisplay(this.row.item.destination);
        },
    },

    methods: {

        getCoordinates(details) {
            const { geoaddress, latitude, longitude } = details;

            const finalGeoaddress = geoaddress || {
                _latitude: latitude,
                _longitude: longitude
            };

            const formattedGeoaddress = LocationUtil.getGeoaddress(finalGeoaddress);
            const { latitude: lat, longitude: lng } = formattedGeoaddress;

            return `(${lat.toFixed(6)}, ${lng.toFixed(6)})`;
        },

        showFormattedDate(date) {
            return DateUtil.getFormattedDateWithTime(date);
        },

        getDisplayValue(value) {
            if (!value || value.length === 0) {
                return '-';
            }
            return value;
        },

        showDispatchLocation(details) {
            const geoaddress = details.geoaddress || {
                _latitude: details.latitude,
                _longitude: details.longitude,
            };

            const params = {
                source: details.source,
                destination: details.destination,
                courierInfo: {
                    driver: details.driver.name,
                    plateNo: details.transportation.plateNo,
                    geoaddress: geoaddress,
                },
            };

            EventBus.$emit('onUpdateSelDispatchLocationView', params);
            this.$bvModal.show('dispatch-alert-report-location-view');
        },
    },
};
</script>

<style scoped></style>



